// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fxn1d","label":"styles_label__2S_nx"};